// extracted by mini-css-extract-plugin
module.exports = {"force_inline":"Link_force_inline__C1PMA","skeleton":"Link_skeleton__sGnpJ"};